export enum OAuth2ClientCommand {
    GenerateDeveloperToken = 'generateDeveloperToken',
    GetSecret = 'getSecret',
    RegenerateClientSecret = 'regenerateClientSecret',
    RegenerateAgentSigningSecret = 'regenerateAgentSigningSecret',
}

export type OAuth2SecretType = 'client' | 'signing';
